import { render, staticRenderFns } from "./jumpCustom.vue?vue&type=template&id=3ee38dce&scoped=true"
import script from "./jumpCustom.vue?vue&type=script&lang=js"
export * from "./jumpCustom.vue?vue&type=script&lang=js"
import style0 from "./jumpCustom.vue?vue&type=style&index=0&id=3ee38dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee38dce",
  null
  
)

export default component.exports